import {getItemLocalStorage} from "../../../Utils/utils";

export const GET_ENTITIES_BY_FILTER = "GET_ENTITIES_BY_FILTER";
export const ERROR_GET_ENTITIES_BY_FILTER = "ERROR_GET_ENTITIES_BY_FILTER";

// =========================================================================
//                             GETS ENTITIES
// =========================================================================

// -------------------------
// GENERAL
// -------------------------

export function getEntitiesByFilter(filter, time_init, from) {
    // console.log("actionsEntities::getEntitiesByFilter()::timing --> [" + (new Date().getTime() - time_init) + " ms] | from=[" + from + "]");

    return (dispatch, getState) => {
        let datos = {...filter}

        let dataLS = getItemLocalStorage('initDataBE-entityList')
        let viewerLatlng = getItemLocalStorage('viewerLatLng')
        if (dataLS){
            // console.log("actionsEntities::getEntitiesByFilter() -> HAY entityList LocalStorage -> [" + (new Date().getTime() - time_init) + " ms] | from=[" + from + "]")
            dispatch({type: ERROR_GET_ENTITIES_BY_FILTER, payload: undefined});
            dispatch({type: GET_ENTITIES_BY_FILTER, payload: dataLS});
        } else {
            // console.log("actionsEntities::getEntitiesByFilter() -> NO HAY entityList LocalStorage -> call /api/busqueda/entity")

            $.ajax({
                //Cambiar a type: POST si necesario
                type: "GET",
                //Datos que se envian
                //data: JSON.stringify(datos),
                data: datos,
                // Formato de datos que se espera en la respuesta
                dataType: "json",
                beforeSend: function (req) {
                    if(viewerLatlng?.lat) req.setRequestHeader('adopta-viewer-latitude', viewerLatlng?.lat);
                    if(viewerLatlng?.lng) req.setRequestHeader('adopta-viewer-longitude', viewerLatlng?.lng);
                },
                // URL a la que se enviará la solicitud Ajax
                url: "/api/busqueda/entity",
            })
                .done(function (response, textStatus, jqXHR) {
                    // console.log("actionsEntities::getEntitiesByFilter()::AJAXdone()::timing --> [" + (new Date().getTime() - time_init) + " ms] | from=[" + from + "]");

                    dispatch({type: ERROR_GET_ENTITIES_BY_FILTER, payload: undefined});
                    dispatch({type: GET_ENTITIES_BY_FILTER, payload: response});
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    // console.log("actionsProtectora::getEntitiesByFilter()::ajax.fail");
                    let errorStr;
                    if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON !== undefined){
                        errorStr = jqXHR.responseJSON.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                    } else {
                        errorStr = jqXHR.responseJSON;
                    }

                    if (console && console.log){
                        console.log("La solicitud a fallado: " + errorStr);
                    }

                    dispatch({type: ERROR_GET_ENTITIES_BY_FILTER, payload: errorStr});
                });
        }
    }

}


export function getAllEntities(metadata) {
    return (dispatch, getState) => {
        // console.log("actionsEntities::getAllEntities()");
        let viewerLatLngStr, viewerLatlng
        try {
            viewerLatLngStr = localStorage?.getItem('viewerLatLng');
            if (viewerLatLngStr) viewerLatlng = JSON.parse(viewerLatLngStr)
        } catch (e) {
            console.log("LocalStorage is not accesible");
        }

        let datos = {metadata: metadata}
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: datos,
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            beforeSend: function (req) {
                if(viewerLatlng?.lat) req.setRequestHeader('adopta-viewer-latitude', viewerLatlng?.lat);
                if(viewerLatlng?.lng) req.setRequestHeader('adopta-viewer-longitude', viewerLatlng?.lng);
            },
            // URL a la que se enviará la solicitud Ajax
            url: "/api/busqueda/entity",
        })
            .done(function (response, textStatus, jqXHR) {
                // console.log("actionsProtectora::getAllEntities()::ajax.done");
                // console.log(response);
                dispatch({type: ERROR_GET_ENTITIES_BY_FILTER, payload: undefined});
                dispatch({type: GET_ENTITIES_BY_FILTER, payload: response});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                // console.log("actionsProtectora::getAllEntities()::ajax.fail");

                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined){
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log){
                    console.log("La solicitud a fallado: " + errorStr);
                    console.log(errorStr);
                }

                dispatch({type: ERROR_GET_ENTITIES_BY_FILTER, payload: errorStr});
            });
    }
}


export function resetAllEntities() {
    //console.log("actionsRecomendations::resetAnimalsRecomendation()");
    return (dispatch, getState) => {
        dispatch({type: GET_ENTITIES_BY_FILTER, payload: {}});
    }
}

export function resetinfoEntity() {
    // console.log("******************************");
    // console.log(" ***  RESET ENTITY DETAIL  ***");
    // console.log("******************************");
    return (dispatch, getState) => {
        dispatch({type: GET_ENTITY_BY_PERMALINK, payload: {infoEntity: {}}});
    }
}

// **************************CARTAS DETALLES ANIMAL*******************************


